<!-- 右侧详情 -->
<template>
<div :class="mobileClass('cm_duty_box')">
   <div class="cm_duty_intro">
      <!-- 标题 -->
      <div class="cm_duty_intro_title">
        <h3>{{data.title}}</h3>
        <span>您的位置：{{data.title}}</span>
      </div>
      <!--<img src="@/assets/img/bg-logo.png">-->
      <!-- 内容 -->
      <div class="cm_duty_intro_content" v-loading="loading">
          <h4 v-if="cutData[0]">{{cutData[0].TITLE}}</h4>
          <p v-if="cutData[0]" v-html="cutData[0].CONTENT"></p>
      </div>
    </div>
</div>
</template>

<script>
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
props:["data"],
data() {
//这里存放数据
return {
  url:"",
  cutData:"",
  ele:"",
  windowWidth:document.documentElement.clientWidth,
  loading:true
};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$route': function (to, from) {
    this.loadItem()
  },
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  httpPost() {
    this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.ele.data 
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.cutData = data.data.pdList
          this.loading = false
        }
          
      });
    },
    loadItem() {
      let list = this.data.children;
      for (let i = 0; i < list.length; i++) {
        if (list[i].fullPath == this.$route.path) {
          this.ele = list[i]
          this.url = this.ele.url
          this.httpPost()
        }
      }
    },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.loadItem()
},

}
</script>
<style >
.cm_duty_intro{
  width: 800px;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  padding: 0 20px;
  position: relative;
  overflow: hidden;
}
.cm_duty_intro_title{
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379D3;
}
.cm_duty_intro_title>h3{
  font-size: 20px;
  font-weight: 500;
  color: #4379D3;
}
.cm_duty_intro_title>span{
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_duty_intro_content{
  min-height: 400px;
}
.cm_duty_intro_content>h4{
  display: block;
  font-size: 22px;
  font-weight: 600;
  color: #000000;
  padding: 30px 0;
}
.cm_duty_intro_content>p{
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  padding: 20px 0;
}
.cm_duty_intro>img{
  position: absolute;
  bottom: 10px;
  right: 0;
}
.mobile_cm_duty_box>.cm_duty_intro{
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  padding: 0 20px;
  position: relative;
  overflow: hidden;
}
.mobile_cm_duty_box img{
  max-width: 100%;
}
</style>